import { Center, CenterProps } from '@mantine/core';
import { ReactNode } from 'react';

interface CenteredLayoutProps extends CenterProps {
  children: ReactNode;
}

export function CenteredLayout({ children, ...rest }: CenteredLayoutProps) {
  return (
    <Center sx={{ minHeight: '100vh', width: '100%' }} {...rest}>
      {children}
    </Center>
  );
}
